<!-- 群聊工单item -->
<template>
  <!-- 导诊类工单无法取消置顶 -->
  <a-popover
    :overlayStyle="{ display: isGuide ? 'none' : 'block' }"
    placement="right"
    trigger="contextmenu"
  >
    <!-- 系统级的不能取消 所以不展示-->
    <template #content>
      <span class="set-topping" @click="handleTop">
        {{ isTop ? '取消置顶' : '置顶' }}
      </span>
    </template>
    <div
      class="order-item"
      :class="{
        'check-item': isCheck,
        topping: isTop
      }"
      @click="doItNow"
    >
      <div class="z-flex order-item-title">
        <a-badge :count="info.msgCount" :overflow-count="99">
          <div class="left" :class="{ threeImg: avatarList.length === 3 }" v-if="avatarList.length">
            <span v-for="it in avatarList" :key="it">
              <auth-img :src="it" />
            </span>
          </div>
        </a-badge>
        <div class="right z-flex">
          <div class="header z-flex">
            <div class="chatName">
              <div class="complaint-img" v-if="info.isComplaint">
                <a-image :src="complaintImg" />
              </div>
              <div class="group-name">{{ info.groupName }}</div>
              <div class="we-com-new-message" v-if="hasWeComNewMessage">
                <auth-img class="we-com-img" :src="weComNewMessageImg" />
                <div>待回复</div>
              </div>
            </div>
            <div class="time">
              {{ formatTime(chatRecord.timestamp || chatRecord.time) }}
            </div>
          </div>
          <div class="msg z-flex-c">
            <span class="textArea" style="min-height: 16px">{{ handleChat(info) }}</span>
            <div class="status">
              <div v-if="timeRollBack?.countdown">
                <div class="rollbackTimer" v-if="timeRollBack?.countdown > rollBackSplit">
                  {{ timeRollBack?.formatTime || '--' }}
                </div>
                <div class="closeToRollBack" v-else>
                  <span class="close">回滚</span>
                  <span class="timer">{{ timeRollBack?.formatTime || '--' }}</span>
                </div>
              </div>
              <div class="hungup-img z-flex-c" v-if="info.suspendNumber">
                <div><auth-img src="@/assets/img/work-place/hungup.png" /></div>
                <span>{{ info.suspendNumber }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-popover>
</template>
<script setup>
import { defineEmits, defineProps, computed, onMounted, createVNode } from 'vue'
import { useStore } from 'vuex'
import { handleWorkStatus } from '@/views/WorkPlace/hooks/workOrder'
import getCurrentGroupInfo from '@/views/hooks/getCurrentGroupInfo'
import EventBus from '@/utils/EventBus.js'
import Config from '@/config/index'
import { formatTime } from '@/utils'
import useGroupOrder, { computeGroupId } from './hooks/useGroupOrder'
import { message } from 'ant-design-vue'
import { CLOSE_CURRENT_IM, REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'
import { guideRecommendedInfo } from '@/api/workPlace/workOrder'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

import complaintImg from '@/assets/img/work-place/complaint.png'
import weComNewMessageImg from '@/assets/img/chat/wechat2.png'
const store = useStore()
const erpId = computed(() => store.getters.userInfo.erpId)
const ucUserId = computed(() => store.getters.userInfo.ucUserId)
const props = defineProps({
  info: {
    type: Object,
    required: true,
    default: () => {}
  },
  isTop: {
    // 是否置顶标识
    type: Boolean,
    required: false,
    default: false
  },
  isGuide: {
    // 是否导诊咨询工单
    type: Boolean,
    required: false,
    default: false
  }
})
const curGroupId = computed(() => {
  const { groupType, groupId, assistantPatientGroupId, guideConsultGroupId, doctorDaGroupId } =
    props.info
  const id = computeGroupId(
    guideConsultGroupId,
    groupId,
    doctorDaGroupId,
    assistantPatientGroupId,
    groupType
  )
  return id
})
const chartId = computed(() => store.state.workOrder.chartId)
const { avatarList } = useGroupOrder(props.info, ucUserId.value)

const emit = defineEmits(['handleTop', 'doItNow'])
// 判断当前是不是会话中
const isCheck = computed(() => chartId.value === curGroupId.value)
const chatRecord = computed(() => props.info.chatRecord || {})
// 聚合工单通过 suspendWorkOrderIds 关联具体工单，不复用原 IM 未读数逻辑
const hasWeComNewMessage = computed(() => {
  const suspendWorkOrderIds = props.info?.suspendWorkOrderIds || []
  const workOrderMap = store.state.workOrder.weComNewMessageWorkOrderMap || {}
  const activeWorkOrderId = store.state.workOrder.activeWeComWorkOrderId
  return Boolean(
    props.info?.weComHasNewMessage ||
      suspendWorkOrderIds.some(workOrderId => {
        const id = String(workOrderId)
        return id !== activeWorkOrderId && workOrderMap[id]
      })
  )
})

onMounted(() => {
  if (isCheck.value) {
    doItNow()
  }
})

const timerCollection = computed(() => store.state.rollBack.roundInstance)
const timeRollBack = computed(() => timerCollection.value.get(curGroupId.value))
const rollBackSplit = computed(() => store.state.rollBack.rollBackSplit)

function handleTop() {
  // 系统默认的不能取消置顶
  if (props.isGuide) return
  const curTopObj = JSON.parse(localStorage.getItem('TOP_LIST')) || {}
  const curTopList = curTopObj[erpId.value] || []
  const index = curTopList.findIndex(it => it === curGroupId.value)
  if (index > -1) {
    // 取消置顶
    curTopList.splice(index, 1)
  } else {
    // 置顶
    curTopList.push(curGroupId.value)
  }
  curTopObj[`${erpId.value}`] = curTopList
  localStorage.setItem('TOP_LIST', JSON.stringify(curTopObj))
  emit('handleTop', props.info, !props.isTop)
}

// 点击处理中工单
function doItNow() {
  handleWorkStatus()
    .then(() => {
      emit('doItNow', { res: null, load: true })
      //防止重复监听
      EventBus.off('memberJoinPublicGroupSuccess')
      const cb = function (res) {
        emit('doItNow', { res, load: false })
      }
      store.commit('workOrder/SET_CHART_ID', curGroupId.value)
      // 获取当前群组信息
      getCurrentGroupInfo().then(res => {
        const dealWorkOrderList = res?.workOrderGroupInfo?.dealWorkOrderList || []
        if (!dealWorkOrderList.length) {
          message.warning('工单已回滚')
          CLOSE_CURRENT_IM?.emit()
          cb(null)
          return
        }
        const tipMessage = res?.workOrderGroupInfo?.tipMessage || ''
        tipMessage && message.warning(tipMessage)
        cb(res)
        // 导诊群查看推荐信息
        if (res.workOrderGroupInfo.groupType === 3) {
          guideInfoToSummary(res)
        }
      })
    })
    .catch(() => {
      REFRESH_LIST?.emit()
    })
}

function guideInfoToSummary(res) {
  const workOrderId = res.workOrderGroupInfo.targetWorkOrder.workOrderId
  guideRecommendedInfo({
    workOrderId
  }).then(res => {
    const { summaryInformFlag, summaryId } = res
    const text = '医助-AI已通过预问诊生成小结，并存至档案的小结内，可视情况选择是否要发送给患者。'
    if (summaryInformFlag === 0 && summaryId) {
      Modal.confirm({
        title: () => '提示',
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () => createVNode('div', { style: 'color:black' }, text),
        okText: () => '去查看',
        cancelText: () => '知道了',
        onOk() {
          store.commit('app/SET_TABS_ACTIVE', 'summary')
        },
        onCancel() {}
      })
    }
  })
}
// 展示最后一条聊天消息
function handleChat(info = {}) {
  const { chatRecord = {}, msgCount = 0 } = info
  //未读数量
  const unreadNum = msgCount > 0 ? (msgCount < 99 ? msgCount : '99+') : ''
  const { from = '' } = chatRecord
  //发送人
  const chatName = renderName(from, info)
  //未读数量 + 发送人姓名 + 消息内容
  return (unreadNum && `[${unreadNum}条]`) + chatName + renderChatMsg(chatRecord)
}
//消息缩略语
const renderChatMsg = (chatRecord = {}) => {
  const { msgType = '', contentsType = '', msg = '', bodies = {}, customEvent = '' } = chatRecord
  if (msgType === 20001 || contentsType === 'txt') return bodies.msg || msg
  if (msgType === 20002 || contentsType === 'img') return '[图片]'
  if (msgType === 20003 || contentsType === 'audio') return '[语音]'
  if (msgType === 20004 || contentsType === 'video') return '[视频]'
  if (!bodies) return ''
  if (Config.CHAT_MESSAGE_TXT.includes(msgType || customEvent)) {
    return bodies['toDa'] || msg.toDa || ''
  } else {
    return Config.CHAT_MESSAGE_TYPE[msgType || customEvent] || '[系统消息]'
  }
}
//判断展示用户姓名
const renderName = (id, info) => {
  const {
    assistantInfos = [],
    doctorAssistantInfos = [],
    doctorInfo = {},
    patientInfo = {},
    chatRecord = {},
    doctorHelperInfos = []
  } = info || {}
  const { msgType = '', customEvent = '' } = chatRecord
  const customMsgTypeList = Object.keys(Config.CHAT_MESSAGE_TYPE).concat(Config.CHAT_MESSAGE_TXT)
  //自定义消息类型不展示发送人
  if (customMsgTypeList.includes(`${msgType}`) || customMsgTypeList.includes(customEvent)) return ''
  //自己发送不展示发送人
  if (store.getters.chatId === id || !id) return ''
  //兼容后端返回大小写问题
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return '医生助手：'
  let name = ((doctorInfo && doctorInfo.username) || '') + '医生：'
  //健康管家/BD
  const aUserName = ((assistantInfos && assistantInfos.find(item => item.userId === id)) || {})
    .username
  //医生助手
  const zUserName = (
    (doctorAssistantInfos && doctorAssistantInfos.find(item => item.userId === id)) ||
    {}
  ).username
  //医生学生
  const hUserName = (
    (doctorHelperInfos && doctorHelperInfos.find(item => item.userId === id)) ||
    {}
  ).username
  switch (id.substr(0, 1)) {
    case 'p':
      name = (patientInfo.username || '') + '患者：'
      break
    case 'a':
      name = (aUserName || '') + 'BD：'
      break
    case 'z':
      name = (zUserName || '') + '医生助手：'
      break
    case 'h':
      name = (hUserName || '') + '医生学生：'
      break
    default:
      break
  }
  return name
}
</script>
<style scoped lang="scss">
%light-font {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
%blod-font {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
}
.set-topping {
  cursor: pointer;
}
.order-item {
  @extend %light-font;
  padding: 0 12px;
  cursor: pointer;
  position: relative;

  ::v-deep(.ant-collapse > .ant-collapse-item) {
    border: none;
  }
  &.topping {
    background: #f5f5f5;
  }
  &.check-item {
    background: #eaf4ff;
  }
  &-title {
    padding: 14px 0;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    .left {
      width: 36px;
      height: 36px;
      border-radius: 4px;
      overflow: hidden;
      background-color: #e8e8e8;
      span {
        width: 50%;
        height: 50%;
        display: inline-block;
        text-align: center;
        img {
          width: 17px;
          height: 17px;
        }
        &:nth-child(1),
        &:nth-child(3) {
          text-align: left;
        }
        &:nth-child(2),
        &:nth-child(4) {
          text-align: right;
        }
        &:nth-child(3),
        &:nth-child(4) {
          margin-top: 2px;
        }
      }
      &.threeImg {
        span:first-child {
          width: 100%;
          text-align: center;
        }
        span {
          &:nth-child(2) {
            text-align: left;
          }
          &:nth-child(3) {
            text-align: right;
          }
          &:nth-child(2),
          &:nth-child(3) {
            margin-top: 2px;
          }
        }
      }
    }
    .right {
      width: calc(100% - 36px);
      padding-left: 8px;
      flex-direction: column;
      justify-content: space-between;
      .header {
        // flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        .chatName {
          @extend %blod-font;
          display: flex;
          align-items: center;
          gap: 4px;
          flex: 1;
          min-width: 0;
          .complaint-img {
            width: 30px;
            flex-shrink: 0;
          }
          .group-name {
            min-width: 0;
            overflow: hidden;
            line-height: 1.4;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .we-com-new-message {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            // animation: we-com-new-message-flash 1.2s ease-in-out infinite;
            background: linear-gradient(180deg, #3adb58 0%, #28c445 100%);
            font-size: 10px;
            padding: 1px 4px;
            color: #fff;
            border-radius: 4px;
            .we-com-img {
              animation: we-com-new-message-flash 1.2s ease-in-out infinite;
              width: 18px;
              height: 18px;
            }
          }
        }
        .time {
          // flex: 1 0 auto;
          text-align: right;
          flex-shrink: 0;
        }
      }
      .msg {
        margin-top: 3px;
        .textArea {
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .status {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .rollbackTimer {
          max-height: 16px;
          font-size: 10px;
          padding: 3px 5px;
          background: #e5faef;
          border-radius: 2px;
          color: #60d195;
          display: flex;
          align-items: center;
        }
        .closeToRollBack {
          max-height: 16px;
          font-size: 10px;
          display: flex;
          align-items: center;
          background-color: #fef2f0;
          border-radius: 2px;

          .close {
            width: 27px;
            height: 16px;
            background: #ff4848;
            border-radius: 2px 0 0 2px;
            text-align: center;
            color: #fff;
            margin-right: 5px;
          }
          .timer {
            display: inline-block;
            color: #ff4848;
            background-color: #fef2f0;
            padding-right: 5px;
            border-radius: 2px;
            min-width: 29px;
            text-align: center;
          }
        }
        .hungup-img {
          margin-left: 5px;
          flex-shrink: 0;
          cursor: pointer;
          text-align: right;
          color: #666666;
          img {
            width: 12px;
            height: 12px;
            margin-right: 6px;
          }
        }
      }
    }
  }
  &.check-item {
    .order-item-list {
      ::v-deep(.ant-collapse-borderless) {
        background: #f5faff;
      }
      .collapse-content {
        ::v-deep(.ant-collapse-borderless .ant-collapse-item) {
          border-bottom: initial;
        }
      }
    }
    .order-item-title {
      // border-bottom: none;
      border-bottom: 1px solid #e8e8e800; // 处理选中时跳动
    }
  }
  &-list {
    padding-left: 44px;
    // 折叠面板样式穿透
    ::v-deep(.ant-collapse-borderless) {
      background: #f8f8f8;
      border-radius: 4px;
    }
    ::v-deep(.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header) {
      padding: 8px;
      font-weight: 500;
      font-size: 12px;
      color: #666666;
    }
    ::v-deep(.ant-collapse-content > .ant-collapse-content-box) {
      padding: 0 8px;
      @extend %light-font;
    }

    .list {
      padding: 8px 0;
      &:first-child {
        border-top: 1px solid #e8e8e8;
      }
      .order-title {
        position: relative;
        display: flex;
        align-items: center;
        img {
          margin-right: 4px;
        }
        // 高危的工单
        &.danger {
          &::before {
            content: '';
            position: absolute;
            left: -7px;
            top: 3px;
            display: block;
            width: 4px;
            height: 12px;
            background: #fa0a02;
          }
        }
      }

      .copy {
        width: 10px;
        height: 10px;
        cursor: pointer;
        margin-left: 5px;
      }
    }
  }
}

@keyframes we-com-new-message-flash {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

@media (prefers-reduced-motion: reduce) {
  .we-com-new-message {
    animation: none !important;
  }
}
</style>
